<div class="flex-column">
    <ng-container *ngIf="(this.loadingCase || this.isloadingUpdate) && !!this.isCaseInputParam">
        <div class="flex-row align-center-center full-height spinner-hover">
            <mat-spinner diameter="60"></mat-spinner>
         </div>
    </ng-container>
    <span *ngIf="!this.isCaseInputParam" class="headline-1 pls-4 mbs-5 text-primary-darker-title">
        {{ ('modules.admissions.case-data.template-title' | exp:'':'Datos del caso')  }}
    </span>
    <div [ngClass]="{ 'ml-1': !this.isCaseInputParam }" *ngIf="!this.loadingCase">
        <!-- [ngClass.lt-md]="['mts-3', 'mat-elevation-z4']"  -->
        <app-theme-card themeScope="admissions" cardClass="mts-4 mx-1 data-management-container mat-elevation-z2 p-1">
            <div class="flex-column">
                <form [formGroup]="this.formCase">
                    <div class="flex-column">
                        <div *ngIf="!this.caseIN" class="flex-row mbs-3">
                            <span class="text-primary-darker-h3 pl-2">
                                {{ 'modules.admissions.case-data.case-management' | exp:'':'Gestión del caso' }}
                            </span>
                        </div>

                        <div class="flex-column px-2">
                            <div class="flex-row flex-100 space-between-center">
                                <!-- Financier -->
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.financier' | exp:'':'Financiador' }} *
                                    </span>
                                    <app-select-searching-input
                                        [name]="this.FINANCIER" [nameSearching]="this.FINANCIER_SEARCHING"
                                        [form]="this.formCase" [placeholder]="('modules.admissions.case-data.placeholders.select-financier' | exp:'':'Seleccionar financiador')"
                                        [elements]="this.financiers" [placeholderNoValue]="('modules.admissions.case-data.placeholders.no-value' | exp:'':'Sin resultados')"
                                        [placeholderSearching]="('modules.admissions.case-data.placeholders.searching-financier' | exp:'':'Buscar financiador...')"
                                        (selected)="onSelectFinancier($event)"
                                        [calculateId]="this.calculateIdFinancier" [calculateName]="this.calculateNameFinancier"
                                        [defaultValue]="this.financierIdToEdit"
                                        [disabled]="!!this.caseIN ? true : false">
                                    </app-select-searching-input>
                                </div>

                                <!-- Gestor -->
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.case-manager' | exp:'':'Gestor del caso' }}
                                    </span>
                                    <app-text-input [name]="this.FINANCIER_OPERATOR"
                                        [form]="this.formCase">
                                    </app-text-input>
                                </div>
                            </div>

                            <div class="flex-row flex-100 space-between-center">
                                <!-- Date email -->
                                <div class="flex-row space-between-center flex-45">
                                    <div class="flex-column flex-45">
                                        <span class="subtitle-3 text-primary-darker mbs-1">
                                            {{ 'modules.admissions.case-data.email-date' | exp:'':'Fecha de mail' }}
                                        </span>
                                        <app-date-picker [name]="this.EMAIL_DATE" [form]="this.formCase">
                                        </app-date-picker>
                                    </div>
                                    <div class="flex-column flex-45">
                                        <span class="subtitle-3 text-primary-darker mbs-1">
                                            {{ 'modules.admissions.case-data.start-date' | exp:'':'Fecha de inicio de actividad' }}
                                        </span>
                                        <app-date-picker [name]="this.START_DATE" [form]="this.formCase">
                                        </app-date-picker>
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.email-financier' | exp:'':'Mail del financiador' }}
                                    </span>
                                    <app-email-input [name]="this.EMAIL_FINANCIER" [form]="this.formCase"
                                        [placeholder]="('modules.admissions.case-data.placeholders.email' | exp:'':'ejemplo@mail.com')" class="inputMail">
                                    </app-email-input>
                                </div>
                            </div>

                            <!-- Affiliaton -->
                            <div class="flex-row space-between-center">
                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.patient-afiliation-number' | exp:'':'Nº de afiliado' }}
                                    </span>

                                    <app-text-input [name]="this.PATIENT_AFFILIATIONNUMBER" [form]="this.formCase" (keypress)="keyPressNumbers($event)"
                                        [placeholder]="''" [hint]="('modules.admissions.case-data.hints.numeric-code' | exp:'':'Números del 0 al 9, - y /')">
                                    </app-text-input>
                                </div>

                                <div class="flex-column flex-45">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.financier-internal-code' | exp:'':'Código interno financiador (CIF)' }}
                                    </span>
                                    <app-text-input [name]="this.FINANCIER_INTERNAL_CODE" [form]="this.formCase" [placeholder]="''" (keypress)="keyPressNumbers($event)" [hint]="('modules.admissions.case-data.hints.numeric-code' | exp:'':'Números del 0 al 9, - y /')">
                                    </app-text-input>
                                </div>
                            </div>

                            <div class="flex-row flex-100  space-between-center mt-1">
                                <div class="flex-column flex-30">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.company-type' | exp:'':'Tipo de empresa' }}
                                    </span>
                                    <app-select-input [name]="this.COMPANY_TYPE"
                                        [elements]="this.companyTypesList" [form]="this.formCase" (selected)="onSelectCompanyType($event)"
                                        [defaultValue]="!!this.caseIN?.companyType ? this.caseIN.companyType.id.toString() : ''"
                                        [noOptionText]="('modules.admissions.case-data.placeholders.no-option' | exp:'':'Sin especificar')"
                                        [calculateName]="this.calculateNameCompanyType" [calculateId]="this.calculateIdCompanyType" [disabled]="isDisabledCompanyType">
                                    </app-select-input>
                                </div>
                                <div class="flex-column flex-30">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.vat' | exp:'':'IVA' }}
                                    </span>
                                    <app-select-input [name]="this.VAT_CATEGORY" [defaultValue]="isDisabledVatCategory || !!this.caseIN?.vatCategory ? this.vatCatId : ''" [noOptionText]="('modules.admissions.case-data.placeholders.no-option' | exp:'':'Sin especificar')"
                                        [elements]="this.vatCategories" [form]="this.formCase" [calculateName]="this.calculateNameVatCategory" [calculateId]="this.calculateIdVatCategory" [disabled]="isDisabledVatCategory">
                                    </app-select-input>
                                </div>
                                <div class="flex-column flex-30">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.tax-zone' | exp:'':'Zona impositiva' }}
                                    </span>
                                    <app-select-searching-input class="mbs-1" [placeholder]="('modules.admissions.case-data.placeholders.select-tax-zone' | exp:'':'Seleccionar')"
                                        [defaultValue]="this.taxZoneDefault ?? ''"
                                        [forceNumber]="'true'"
                                        [name]="this.TAX_ZONE" [nameSearching]="this.TAX_ZONE_SEARCHING"
                                        [form]="this.formCase"[calculateName]="this.calculateNameTaxZone"
                                        [calculateId]="this.calculateIdTaxZone"
                                        [elements]="this.taxZones"
                                        [placeholderSearching]="('modules.admissions.case-data.placeholders.searching-tax-zone' | exp:'':'Buscar zona impositiva...')">
                                    </app-select-searching-input>
                                </div>
                            </div>

                            <div class="flex-row space-between-center">

                                <div class="flex-column flex-30">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.case-data.case-type' | exp:'':'Tipo de caso' }}
                                    </span>
                                    <app-multi-select-input [name]="this.TYPE_CASE"
                                        [elements]="this.tagList" [form]="this.formCase"
                                        [valuesSelected]="this.tagsDefault">
                                    </app-multi-select-input>
                                </div>

                                <div class="flex-column flex-30">
                                    <span class="subtitle-3 text-primary-darker mbs-1 full-width">
                                        {{ 'modules.admissions.case-data.case-complexity' | exp:'':'Complejidad de caso' }}
                                    </span>
                                <div class="flex-row align-start-none flex-gap-small">
                                    <div class="flex-80">
                                        <app-select-input
                                            [name]="this.COMPLEXITY_CASE"
                                            [form]="this.formCase"
                                            [elements]="this.complexityList"
                                            (selected)="onSelectComplexity($event)"
                                            [defaultValue]="!!this.caseIN?.complexityId ? this.caseIN.complexityId.toString() : ''"
                                            [noOptionText]="('modules.admissions.case-data.placeholders.no-option' | exp:'':'Sin especificar')">
                                        </app-select-input>
                                    </div>
                                        <mat-icon style="cursor: pointer;" [color]="'accent'" (mouseover)="complexitiesHelp()" (mouseout)="complexitiesHelp()" cdkOverlayOrigin #originOverlay="cdkOverlayOrigin">help_outline</mat-icon>
                                        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOffsetX]="-280" [cdkConnectedOverlayOffsetY]="275" [cdkConnectedOverlayOrigin]="originOverlay" [cdkConnectedOverlayOpen]="isOpen" cdkConnectedOverlayWidth="20%">
                                            <div *ngFor="let complexity of this.complexityList" class="complexity-item">
                                                <span style="font-size: small; border-bottom: 0.1px solid var(--color-grey-medium); ">{{complexity.name}}  :  </span>
                                                <br>
                                                <span style="font-size: smaller;">  {{complexity.description}}  </span>
                                            </div>
                                        </ng-template>
                                </div>
                                </div>
                                <div class="flex-column flex-30">
                                    <div class="flex-row flex">
                                    <span class="subtitle-3 text-primary-darker">
                                        {{ 'modules.admissions.case-data.case-visibility' | exp:'':'Visibilidad de caso' }}
                                    </span>
                                    </div>
                                    <div class="flex-row">
                                        <app-checkbox-input class="subtitle-3 text-primary-darker" [form]="this.formCase"
                                            [label]="('modules.admissions.case-data.financier' | exp:'':'Financiador')"
                                            [name]="this.ENABLED_FINANCIER">
                                        </app-checkbox-input>
                                        <app-checkbox-input class="subtitle-3 text-primary-darker" [form]="this.formCase"
                                            [label]="('modules.admissions.case-data.labels.provider-group' | exp:'':'Grupo de prestadores')"
                                            [name]="this.ENABLED_PROVIDER">
                                        </app-checkbox-input>
                                    </div>
                                </div>
                            </div>

                            <div class="flex-row flex-100 mbs-3 ">
                                  <!-- Diagnóstico -->
                                <div class="flex-column flex-45">
                                    <span class="text-primary-darker-h3">
                                        {{ 'modules.admissions.case-data.diagnosis' | exp:'':'Diagnóstico' }}
                                    </span>
                                </div>
                            </div>
                                <div [formGroup]="this.formObservations">
                                    <div [formArrayName]="this.OBSERVATIONS">
                                        <div *ngFor="let observation of observations['controls']; let i=index">
                                            <div [formGroupName]="i">
                                                <div class="flex-row" style="gap: 4rem;">
                                                    <div class="flex-column flex-30">
                                                            <span class="subtitle-3 text-primary-darker mbs-1">
                                                                {{ 'modules.admissions.case-data.select-diagnosis' | exp:'':'Seleccionar dx' }}
                                                            </span>
                                                            <app-select-searching-dynamic-input
                                                                id="diagnosis-select"
                                                                [defaultValue]="this.actualDiagnoses[i]"
                                                                [elements]="this.diagnosesOnSelect[i]"
                                                                [name]="this.DIAGNOSIS" [nameSearching]="this.DIAGNOSIS_SEARCHING"
                                                                [form]="getObservationsFormGroup(i)"
                                                                [placeholder]="('modules.admissions.case-data.placeholders.select-diagnosis' | exp:'':'Seleccionar diagnóstico')" [placeholderNoValue]="('modules.admissions.case-data.placeholders.no-value' | exp:'':'Sin resultados')"
                                                                [placeholderSearching]="('modules.admissions.case-data.placeholders.searching-diagnosis' | exp:'':'Buscar diagnóstico...')"
                                                                [httpGet]="this.getDiagnosesByName"
                                                                [noOptionText]="('modules.admissions.case-data.placeholders.no-option' | exp:'':'Sin especificar')"
                                                                [calculateName]="this.calculateName"
                                                                [matTooltip]="!!this.diagnosesOnSelect[i] ? !!this.diagnosesOnSelect[i][0] ? this.diagnosesOnSelect[i][0].name : null : null">
                                                            </app-select-searching-dynamic-input>
                                                    </div>
                                                        <!-- Observación -->
                                                        <div class="flex-column flex-100">
                                                            <span class="subtitle-3 text-primary-darker mbs-1">
                                                                {{ 'modules.admissions.case-data.observation' | exp:'':'Observación' }}
                                                            </span>
                                                            <app-text-input [clearable]="true"
                                                                [name]="this.OBSERVATION"
                                                                [form]="getObservationsFormGroup(i)">
                                                            </app-text-input>
                                                        </div>
                                                        </div>

                                                    <!-- BUTTONS -->
                                                   <div class="flex-row align-end-center">
                                                            <div class="flex-row">
                                                                <button mat-icon-button [color]="'primary'"
                                                                    (click)="this.removeObservation(i)">
                                                                    <mat-icon>delete_outlined</mat-icon>
                                                                </button>
                                                            </div>
                                                            <div class="flex-row">
                                                                <button mat-icon-button [color]="'primary'" [matTooltip]="('common.add' | exp:'':'Agregar')"
                                                                    [disabled]="!(!!this.formObservations['controls']['observations']['controls'][i]['controls']['id']['value'])"
                                                                    [hidden]="!((i+1)==this.formObservations['controls']['observations']['controls'].length)"
                                                                    (click)="this.addObservation()">
                                                                    <mat-icon>add_circle_outlined</mat-icon>
                                                                </button>
                                                            </div>
                                                    </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- Buttons if input param case -->
                    <div class="mt-2"></div>
                    <div *ngIf="this.isCaseInputParam" class="flex-row align-space-around-center full-width">
                        <button mat-stroked-button [color]="'primary'" (click)="clickCancelEditCase()">
                            <span>{{ ('common.cancel' | exp:'':'Cancelar')  }}</span>
                        </button>
                        <button mat-flat-button [color]="'primary'" [disabled]="!this.formCaseDataValid || !this.isValidFormObservations" (click)="clickConfirmEditCase()">
                            <span>{{ ('common.confirm' | exp:'':'Confirmar')  }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </app-theme-card>
    </div>
</div>
